// extracted by mini-css-extract-plugin
module.exports = {"intercom-drag-handle":"intercom-drag-handle___2KDVs","is-dragging":"is-dragging___ZHeKN","grip":"grip___3sBln"};